<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <input v-model="value" type="text" @change="setChangedData(true)">
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'search-facet';

export default {
    name: 'search-facet-options',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Facet Property Name',
            value: '',
            message: '',
        };
    },

    watch: {
        value() {
            this.selectedElements[0].facetPropertyName = this.value;
            this.onOptionChange(this.value);
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.value);
        },
    },

    methods: {
        onSelectedElement() {
            let valueNew = '';

            if (this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME)) {
                valueNew = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);
            }

            this.value = valueNew;
        },
    },
};
</script>
